/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationAiSettingsUpdate } from '../../axios/organisationAiSettingsUpdate'
import type {
	OrganisationAiSettingsUpdateError,
	OrganisationAiSettingsUpdatePathParams,
	OrganisationAiSettingsUpdateRequest,
	OrganisationAiSettingsUpdateResponse,
} from '../../types/OrganisationAiSettingsUpdate'

export const organisationAiSettingsUpdateMutationKey = () =>
	[{ url: '/organisations/:organisation/ai-settings' }] as const

export type OrganisationAiSettingsUpdateMutationKey = ReturnType<typeof organisationAiSettingsUpdateMutationKey>

export type OrganisationAiSettingsUpdateVariables = {
	organisation: OrganisationAiSettingsUpdatePathParams['organisation']
	data: OrganisationAiSettingsUpdateRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAiSettingsController.php OrganisationAiSettingsController::update */
export function useOrganisationAiSettingsUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationAiSettingsUpdateResponse,
		AxiosError<OrganisationAiSettingsUpdateError>,
		OrganisationAiSettingsUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationAiSettingsUpdateMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationAiSettingsUpdateVariables) =>
			organisationAiSettingsUpdate(organisation, data, config).then(res => res.data),
		...options,
	})
}
